import _ from 'lodash';
import React from 'react';

/**
 * @description Renders a formatted read-only text view.
 * Supports single values or arrays. If an array is provided, elements are joined by a custom separator.
 * Implements validation logic to display a fallback "---" if the value is:
 * - Nil (null/undefined)
 * - An empty array
 * - An array containing exclusively nil values.
 * @param {any} value - The data to be displayed (Primitive or Array).
 * @param {string} customValuesSeparator - The string used to concatenate array elements.
 * @example
 * // Renders: <span>Red / Blue / Green</span>
 * TextModeView({['Red', 'Blue', 'Green']}, " / ")
 * // Renders fallback: <span class="read-only-empty-field">---</span>
 * TextModeView({[null, undefined]}, ", ")
 */
export const TextModeView = (value: any, customValuesSeparator: string) => {
  const hasValue =
    (!_.isArray(value) && !_.isNil(value) && value !== '') ||
    (_.isArray(value) && !_.isEmpty(value) && !_.every(value, _.isNil));

  return (
    <div className={'read-only-text'}>
      {hasValue ? (
        <span>
          {_.isArray(value) ? value?.join(customValuesSeparator) : value}
        </span>
      ) : (
        <span className={'read-only-empty-field'}>---</span>
      )}
    </div>
  );
};
